export default __webpack_public_path__ + "static/media/wimmelbild.a5aa75c7.jpg";